"use client"

import React, {useEffect} from 'react'
import {Badge, Card, SimpleGrid, Skeleton, Text, UnstyledButton} from "@mantine/core";
import {TDocumentDTO} from "@/service/admin/DocumentService";
import {loadRelatedDocuments} from "@/service/IndexService";
import {IconAt, IconBuildingWarehouse, IconPhone, IconPhoneFilled} from "@tabler/icons-react";

const Page = () => {

    return (
        <div className="min-h-[500px] lg:w-[1200px] md:w-[600px] mx-auto space-y-6">

            <div className="flex justify-center text-3xl font-bold">
                本站介紹
            </div>

            <div className="space-y-8">
                <div className="flex flex-col gap-3 text-lg">
                    <div className="text-3xl font-black">緣起及目的</div>
                    <p>學術知識的傳播，除透過期刊發表外，學術會議亦是促進知識交流與拓展人脈的重要途徑，同時更是推動領域進步與議題創新的關鍵環節，具有高度的參考價值。然而，目前國內缺乏一個能整合各類學術會議資訊的專屬平台，為促進臺灣學術研究成果的分享與傳播，並提升我國學術會議活動的能見度，國家科學及技術委員會（簡稱國科會）挹注資源，建置「臺灣學術會議資訊平台」（TCC），無償提供會議活動資訊的發布、報名系統、活動查詢及資料典藏等服務。</p>
                    <p>此外，會議論文往往是學者在研究發表前的重要成果展現與同儕交流方式，具有一定的學術價值。由於會議論文傳播管道多元，蒐集與保存相對不易，一般出版社或圖書館目錄也鮮少完整收錄。因此，TCC 的建置，正是為了彌補這項資訊斷層與缺口，提供完善的典藏機制，讓學術會議成果得以長期保存與利用，進而支持臺灣學術知識的持續傳承與創新發展。</p>
                </div>

                <div className="flex flex-col gap-3 text-lg">
                    <div className="text-3xl font-black">平台簡介</div>
                    <p>TCC平台係配合國科會推動學術開放取用之宗旨，並依國內學術單位需求，建立一個不以利益為導向，可有效支援學術活動資訊發布、整合查詢、會議論文資料典藏的開放平台。</p>
                </div>

                <div className="flex flex-col gap-3 text-lg">
                    <div className="text-3xl font-black">網站使用與免責聲明</div>
                    <p>使用者可於TCC平台公開瀏覽各項活動資訊，並應遵守學術倫理，妥善使用相關資料，於利用前，請自行判斷內容之合法性與適宜性。本平台所提供之資料與檔案，均由各活動單位協力提供，TCC平台僅作為資訊彙整與典藏之服務平台，不對其內容之正確性、完整性或即時性進行背書或保證。有關詳細之使用規範，請參閱【相關文件】內之「臺灣學術會議資訊平台（TCC）規範說明」。</p>
                </div>

                <div className="flex flex-col gap-3 ">
                    <div className="text-3xl font-black">相關網站連結</div>

                    <ul className="flex flex-col gap-3 list-disc list-inside">
                        <li>
                            <UnstyledButton component="a" target={"_blank"} href={"https://www.nstc.gov.tw/"} className="underline text-blue-500 text-xl">國科會</UnstyledButton>
                        </li>
                        <li>
                            <UnstyledButton component="a" target={"_blank"} href={"https://toaj.stpi.niar.org.tw/"} className="underline text-blue-500 text-xl">臺灣學術期刊開放取用平台TOAJ</UnstyledButton>
                        </li>
                    </ul>
                </div>



            </div>

        </div>
    )
}
export default Page
